import { useEffect, useRef } from 'react'
import { useColorScheme } from '@mui/material/styles'
import { endThemeTransition, startThemeTransition, THEME_TRANSITION_MS } from '../../styles/theme/themeTransition'

export const ThemeTransition: React.FC = () => {
  const { mode, systemMode } = useColorScheme()
  const resolvedMode = mode === 'system' ? systemMode : mode
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    if (!resolvedMode) return

    startThemeTransition()

    const timer = window.setTimeout(() => {
      endThemeTransition()
    }, THEME_TRANSITION_MS)

    return () => {
      window.clearTimeout(timer)
      endThemeTransition()
    }
  }, [resolvedMode])

  return null
}
